import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { SECURITY_API } from "./apiRoutes";

const mutateChangePassword = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${SECURITY_API}/change-password`, data);
};

const useChangePasswordMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateChangePassword,
    ...queryParams,
  });

export default useChangePasswordMutation;
